import React from 'react';
import BlanketTab from '../BlanketTab'; // 👈 using the same content as patterns

const LibraryTab = ({ topCellName, aiLaunchRequestId = 0 }) => {
  return (
    <div style={{ padding: "8px" }}>
      <BlanketTab
        topCellName={topCellName}
        aiLaunchRequestId={aiLaunchRequestId}
      />
    </div>
  );
};

export default LibraryTab;
